import {listStyles} from "@insite/content-library/Widgets/ProductList/ProductListCardList"
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS } from "@tCentro/theme/design";
import { css } from "styled-components";

listStyles.wrapper = {
    css: css`
        margin-top: 10px;
        margin-bottom: 10px;
    `,
}

listStyles.cardList = {
    gridContainer: {
        css: css`
            width: 100%;
            `,
        gap: 0,
    },
}

listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            width: 100%;
            margin-bottom: 4px;
        `,
    },
    gridItem: {
        css: css`
            border-bottom: none;
        `,
    },
}